export const GET_ALLOYFINISHES_STATED = 'GET_ALLOYFINISHES_STATED';
export const GET_ALLOYFINISHES = 'GET_ALLOYFINISHES';
export const GET_ALLOYFINISHES_ENDED = 'GET_ALLOYFINISHES_ENDED';

export const ADD_ALLOYFINISH_STATED = 'ADD_ALLOYFINISH_STATED';
export const ADD_ALLOYFINISH = 'ADD_ALLOYFINISH';
export const ADD_ALLOYFINISH_ENDED = 'ADD_ALLOYFINISH_ENDED';

export const EDIT_ALLOYFINISH_STATED = 'EDIT_ALLOYFINISH_STATED';
export const EDIT_ALLOYFINISH = 'EDIT_ALLOYFINISH';
export const EDIT_ALLOYFINISH_ENDED = 'EDIT_ALLOYFINISH_ENDED';

export const GET_ALLOYFINISH_STATED = 'GET_ALLOYFINISH_STATED';
export const GET_ALLOYFINISH = 'GET_ALLOYFINISH';
export const GET_ALLOYFINISH_ENDED = 'GET_ALLOYFINISH_ENDED';

export const GET_ALL_ALLOYFINISHES_STATED = 'GET_ALL_ALLOYFINISHES_STATED';
export const GET_ALL_ALLOYFINISHES = 'GET_ALL_ALLOYFINISHES';
export const GET_ALL_ALLOYFINISHES_ENDED = 'GET_ALL_ALLOYFINISHES_ENDED';
